// Code for storing and retreiving temporary data

// class with functions for storing and retreiving temporary data 
class CacheService {

  //function to save data to cache
  saveToCache(key, data) {
    sessionStorage.setItem(key, JSON.stringify(data));
  }

  //function to get data from cache
  getFromCache(key) {
    return JSON.parse(sessionStorage.getItem(key));
  }
}

export default new CacheService();
